import {metaSiteOf} from "analytics/metaPixel";

/**
 * How many advertising providers may set cookies on a page, as the cookie banner's first layer counts them
 * (kitecorp/transferify#375). React-free.
 *
 * The count is a first-layer duty in its own right: for German it is how many controllers receive the
 * data (DSK OH Digitale Dienste Rn. 119), and everywhere it is the signal that third parties take part
 * while their names sit one layer down. So it is the count for THIS page: Google and Reddit everywhere,
 * and Meta as a third wherever Meta runs, which is `metaPixel`'s own site rule (the Romanian storefront,
 * and the Romanian pages of the main domain), never the reading language. A reader who switched
 * transferify.ro to English is still on a site Meta runs on, and one who switched the main domain's root to
 * Romanian is not.
 *
 * Counting the visitor's own site rather than every site keeps the banner at its earlier length, as the
 * owner's rule wants it short (owner decision 2026-10-07): the longer "two providers (three on ...)"
 * wrapped the bar to a third line at 1280x720 and squeezed the recipient card's file list behind its header.
 */
export type AdvertisingProviderCount = 2 | 3;

export function advertisingProviderCount(hostname: string, pathname: string): AdvertisingProviderCount {
	return metaSiteOf(hostname, pathname) === null ? 2 : 3;
}
